import { ApplicationError } from '../../components/ApplicationErrorBoundary/errors/ApplicationError';
import { ajaxRetry } from '../../lib-api/ajaxRetry';

import { base, createApiURL, ResponseObj } from '../../lib-api/services/base';
import { ERR_FAILED_CREATE_AUTHORIZATION_CODE } from '../../utilities/error';

export type AuthorizeResponse = {
  code: string;
};

export type AuthorizePayload = {
  clientId?: string;
  redirectUri?: string;
  state?: string;
  scope?: string;
  conditionalScope?: string;
};

export type AuthorizeClient = {
  authorize: (oauthParameters: AuthorizePayload) => Promise<ResponseObj<AuthorizeResponse>>;
};

const authorizeClient: AuthorizeClient = {
  authorize: (oauthParameters) =>
    ajaxRetry({
      data: JSON.stringify(oauthParameters),
      headers: base.headers(),
      method: 'POST',
      url: createApiURL('/api/v1/oauth/authorize'),
    }),
};

export type AuthorizeService = {
  authorize: (oauthParameters: AuthorizePayload) => Promise<AuthorizeResponse>;
};

export const createAuthorizeService = (client: AuthorizeClient): AuthorizeService => ({
  authorize: async (payload) => {
    const response = await client.authorize(payload);

    if (!response.isOk() || !response.data) {
      throw new ApplicationError(ERR_FAILED_CREATE_AUTHORIZATION_CODE);
    }

    return response.data;
  },
});

export const authorizeService = createAuthorizeService(authorizeClient);
